import React, { useState, useEffect, useMemo, forwardRef } from 'react';
import { useTable, useFilters, usePagination, useSortBy } from 'react-table';
import { createRiskColumns, createComplianceColumns } from "./Columns";
import {ITcolumns} from './ITColumns';
import './RiskTable.css'; // Import the CSS file
/*
import ArrowUpRed from "../assets/images/arrow_up_red.png";
import ArrowDownRed from "../assets/images/arrow_down_red.png";
import ArrowUpGreen from "../assets/images/arrow_up_green.png";
import ArrowDownGreen from "../assets/images/arrow_down_green.png";
import Nill from "../assets/images/nill.png";
*/
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";
import { useTranslation } from "react-i18next";

import SortDown from "../../assets/images/sortdown.svg";
import SortUp from "../../assets/images/sortup.svg";


import {openOverlay, setCurrentPageRedux, setPageSizeRedux, setSortByRedux } from "../../store/actions/riskActions";

import { useDispatch } from "react-redux";




const Badge = ({ value, type, data }) => {

    //////console.log("Risks Data ", data)
    let backgroundColor;
    if (value <= 2) {
        backgroundColor = 'bg-BADGE_1';
    } else if (value > 2 && value <= 6) {
        backgroundColor = 'bg-BADGE_2';
    } else if (value > 6 && value <= 12) {
        backgroundColor = 'bg-BADGE_3';
    } else {
        backgroundColor = 'bg-BADGE_4';
    }

    ////console.log("Data ", data, " value: ", value)
    const financialHistory = data.financial_history ? data.financial_history[type] : null;
    const operationalHistory = data.operational_history ? data.operational_history[type] : null;
    const reputationalHistory = data.reputational_history ? data.reputational_history[type] : null;

    const financial = data.financial ? data.financial[type] : null;
    const operational = data.operational ? data.operational[type] : null;
    const reputational = data.reputational ? data.reputational[type] : null;




    let historyFinancial = financialHistory !== null ? (financialHistory - financial > 0 ? ArrowDownGreen : financialHistory - financial < 0 ? ArrowUpRed : Nill) : null;
    let historyOperational = operationalHistory !== null ? (operationalHistory - operational > 0 ? ArrowDownGreen : operationalHistory - operational < 0 ? ArrowUpRed : Nill) : null;
    let historyReputational = reputationalHistory !== null ? (reputationalHistory - reputational > 0 ? ArrowDownGreen : reputationalHistory - reputational < 0 ? ArrowUpRed : Nill) : null;

    return (
        <div className={`badge ${backgroundColor} flex items-center justify-center text-center p-2 mx-2 rounded-[5px] text-white whitespace-nowrap overflow-hidden text-ellipsis min-w-[55px]`}>
            <span className="">{value}</span>
            {/*<img src={ArrowUpRed} alt="Arrow" className="w-4 h-4 ml-1" />*/}
            {type === 'inherent' ? <img src={historyFinancial} alt="Arrow" className="w-4 h-4 ml-1" /> : null}
            {type === 'residual' ? <img src={historyOperational} alt="Arrow" className="w-4 h-4 ml-1" /> : null}
            {type === 'future' ? <img src={historyReputational} alt="Arrow" className="w-4 h-4 ml-1" /> : null}
        </div>
    )
};


const RiskValue = ({ value, type, data, style }) => (
    <div>
        <Badge value={value} type={type} data={data} style={style} />
    </div>
);

const RiskTable = forwardRef(function RiskTable(
    { data, getRisksFN, totalPagesServer, currentPage2, pageSize2, reduxSortBy, mode, department },
    ref
) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const tableColumns = useMemo(
        () =>
            mode === "compliance"
                ? createComplianceColumns(t)
                : createRiskColumns(t),
        [mode, t]
    );

    /*
    const [filterInput, setFilterInput] = useState({
        Department: '',s
        Owner: '',
        Status: ''
    });
*/

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    //const [sortBy, setSortBy] = useState(['ID', 'asc']);

    //////console.log("CurrentPage", currentPage);


    const defaultColumn = React.useMemo(
        () => ({
            Filter: ''
        }),
        []
    );

    
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        gotoPage,
        setPageSize,
        setSortBy, // Destructure setSortBy from useTable
    } = useTable(
        {
            columns: tableColumns,
            data,
            defaultColumn,
            initialState: {
                pageIndex: currentPage -1, pageSize: 10, sortBy: [
                    {
                        id: 'ID', // The accessor for the column you want to sort by
                        desc: true // Set to true for descending order
                    }
                ]
            },
            //autoResetPage: false,
            autoResetSortBy: false,
            autoResetHiddenColumns: false,

        },
        useFilters,
        useSortBy,
        usePagination,


    );



    // Custom function to handle sorting changes
    const handleSortChange = (newSortBy) => {
        ////////console.log('sortBy changed:', newSortBy);
        setSortBy(newSortBy); // Update the sortBy state
        dispatch(setSortByRedux(newSortBy));
    };

    // Example of how to use the custom sort handler
    const onHeaderClick = (column) => {
        const newSortBy = [{ id: column.id, desc: !column.isSortedDesc }];
        handleSortChange(newSortBy);
    };



    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            ////////console.log(newPage);
            setCurrentPage(newPage);
        }
    };


    useEffect(() => {
        //getRisksFN(currentPage, pageSize);
        setPageSize(pageSize2);
        if (reduxSortBy && reduxSortBy?.length > 0) {
            setSortBy(reduxSortBy);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage2, pageSize2, reduxSortBy]);




    useEffect(() => {
        //////console.log("Pages", totalPagesServer)
        setTotalPages(totalPagesServer);
        
        if (reduxSortBy && reduxSortBy?.length > 0) {
            setSortBy(reduxSortBy);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    const handleRowClick = (row) => {
        ////console.log("Row data:", row.original);
        //dispatch(openOverlay(row.original.ID));
    };

    return data?.length > 0 ? (
        <div ref={ref} className="table-container rounded-[20px]">
         
            {/* Render table headers only once */}
            <table {...getTableProps()} className="main-table shadow-lg rounded">
  {/* 1) Header stays gray */}
  <thead className="bg-gray-100" style={{ height: "77px" }}>
    {headerGroups.map((headerGroup) => (
      <tr
        {...headerGroup.getHeaderGroupProps()}
        className="border-b border-gray-300 h-[78px]"
      >
        {headerGroup.headers.map((column) => {
          if (column.dontshow) return null;

          return (
            <th
              {...column.getHeaderProps({
                onClick: () => onHeaderClick(column),
              })}
              className={`cursor-pointer py-2 ${
                column.id === "ID" ? "px-2" : "px-4"
              }`}
            >
              <div className="flex items-center">
                {column.render("Header")}
                <span>
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <img
                        src={SortDown}
                        alt="Sort Down"
                        className="w-4 h-4 ml-1"
                      />
                    ) : (
                      <img
                        src={SortUp}
                        alt="Sort Up"
                        className="w-4 h-4 ml-1"
                      />
                    )
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </th>
          );
        })}
      </tr>
    ))}
  </thead>

  {/* 2) Body rows */}
  <tbody {...getTableBodyProps()}>
    {page.map((row) => {
      prepareRow(row);

      return (
        <tr
          {...row.getRowProps()}
          className="bg-white hover:bg-[#F8F8F8] transition-colors duration-200 cursor-pointer"
        >
          {row.cells.map((cell) => {
            if (cell.column.dontshow) return null;

            const isStatus =
              department?.label === "IT"
                ? cell.column.id === "CIA"
                : cell.column.id === "Status";

            const tdProps = cell.getCellProps({
              onClick: isStatus
                ? (e) => e.stopPropagation()
                : () => dispatch(openOverlay(row.original.ID)),
            });

            return (
              <td
                {...tdProps}
                className={`overflow-hidden text-ellipsis border-t border-gray-200 bg-transparent py-2 ${
                  cell.column.id === "ID" ? "px-2" : "px-4"
                }`}
              >
                {cell.render("Cell")}
              </td>
            );
          })}
        </tr>
      );
    })}
  </tbody>
</table>



            {/* Render Risk Blocks */}
            <div className="xtable">



                <div className="risk-block shadow-xl" style={{ borderBottom: '1px solid #ddd' }}>
                    <div className="risk-block-header"><p>{t("riskTable.blocks.financial")}</p><p className="font-normal font-xs"><span className="mr-2">{t("riskTable.blocks.inherent")}</span><span className="mr-2">{t("riskTable.blocks.residual")}</span><span>{t("riskTable.blocks.future")}</span></p></div>
                    <div className="mt-[19px]">

                        {page.map(row => (
                            <div key={row.id} className="risk-row">

                                <RiskValue value={row.values.financial.inherent} type="inherent" data={row.values} />
                                <RiskValue value={row.values.financial.residual} type="residual" data={row.values} />
                                <RiskValue value={row.values.financial.future} type="future" data={row.values} />
                            </div>
                        )
                        )}
        {/* <div className='h-[10px] bg-[#ffffff]'></div> */}

                    </div>
                </div>

                <div className="risk-block shadow-xl">
                    <div className="risk-block-header"><p>{t("riskTable.blocks.operational")}</p><p className="font-normal font-xs"><span className="mr-2">{t("riskTable.blocks.inherent")}</span><span className="mr-2">{t("riskTable.blocks.residual")}</span><span>{t("riskTable.blocks.future")}</span></p></div>
                    <div className="mt-[19px]">
                        {page.map(row => (
                            <div key={row.id} className="risk-row">
                                <RiskValue value={row.values.operational.inherent} type="inherent" data={row.values} />
                                <RiskValue value={row.values.operational.residual} type="residual" data={row.values} />
                                <RiskValue value={row.values.operational.future} type="future" data={row.values} />
                            </div>
                        ))}
                                {/* <div className='h-[10px] bg-[#ffffff]'></div> */}

                    </div>
                </div>


                <div className="risk-block shadow-xl">
                    <div className="risk-block-header">
                        <p>{mode === 'compliance' ? t("riskTable.category.compliance") : t("riskTable.blocks.reputational")}</p>
                        <p className="font-normal font-xs">
                            <span className="mr-2">{t("riskTable.blocks.inherent")}</span>
                            <span className="mr-2">{t("riskTable.blocks.residual")}</span>
                            <span>{t("riskTable.blocks.future")}</span>
                        </p>
                    </div>
                    <div className="mt-[19px]">
                        {page.map(row => (
                            <div key={row.id} className="risk-row">
                                <RiskValue value={row.values.reputational.inherent} type="inherent" data={row.values} />
                                <RiskValue value={row.values.reputational.residual} type="residual" data={row.values} />
                                <RiskValue value={row.values.reputational.future} type="future" data={row.values} />
                            </div>
                        ))}
                    </div>
                </div>


            </div>



            <div className="pagination flex justify-between text-[#3b3b3b] p-1">
                <div className="flex items-center">
                    <button onClick={() => { handlePageChange(1); dispatch(setCurrentPageRedux(1)) }} disabled={currentPage2 === 1}>
                        <i className="fa fa-angle-double-left"></i>
                    </button>
                    <button className="ml-2 mr-2" onClick={() => { handlePageChange(currentPage2 - 1);  dispatch(setCurrentPageRedux(currentPage2 - 1)); gotoPage(currentPage) }} disabled={currentPage2 === 1}>
                        <i className="fa fa-angle-left"></i>
                    </button>
                    <span>
                        {t("riskTable.pagination.page")} <strong>{currentPage2}</strong> {t("riskTable.pagination.of")} <strong>{totalPages || 1}</strong>
                    </span>
                    <button className="ml-2" onClick={() => { handlePageChange(currentPage2 + 1); dispatch(setCurrentPageRedux(currentPage2 + 1));  gotoPage(currentPage) }} disabled={currentPage2 === totalPages}>
                        <i className="fa fa-angle-right"></i>
                    </button>
                    <button className="ml-2" onClick={() => { handlePageChange(totalPages); dispatch(setCurrentPageRedux(totalPages));  gotoPage(currentPage) }} disabled={currentPage === totalPages}>
                        <i className="fa fa-angle-double-right"></i>
                    </button>

                    <span className='ml-2'></span>
                    <label>
                        {t("riskTable.pagination.pageSize")}:
                        <select value={pageSize2} onChange={(e) => { setPageSize(Number(e.target.value)); dispatch(setPageSizeRedux(Number(e.target.value))) }}>
                            {[10, 20, 30, 40, 50].map(size =>
                            (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            )
                            )}
                        </select>
                    </label>

                    {/* <span className="ml-2">
                        | Go to page:{' '}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                            }}
                            className='border border-[#3b3b3b] rounded-md p-1 w-10'
                        />
                    </span> */}
                </div>
                {/*<div className="flex items-center">
                    <select
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value));
                        }}
                        className='border border-[#3b3b3b] rounded-md p-1 w-100'
                    >
                        {[5, 10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </div>*/}
            </div>


        </div>
    ) : (
        <div ref={ref} className="text-center text-gray-500">
            {t("riskTable.emptyState")}
        </div>
    );
});

RiskTable.displayName = 'RiskTable';

export default RiskTable;